"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genTagComp = void 0;
var react_1 = __importDefault(require("react"));
var Tags_1 = require("../../Tags");
var genLinkOrText_1 = require("./genLinkOrText");
var genTagComp = function (id, d, options) {
    if (options === void 0) { options = {}; }
    var link = (0, genLinkOrText_1.genLinkOrText)(d).link;
    var showOptions = options.showOptions;
    switch (true) {
        case !options.display:
            return (react_1.default.createElement("div", { tabIndex: 0, style: { minWidth: 0 }, onFocus: function (e) { return !showOptions && e.stopPropagation(); } },
                react_1.default.createElement(Tags_1.TagClear, { XS: options.S, grey: true, display: d.display, onClick: function (e) {
                        e.stopPropagation();
                        options.handleSelect(options.single_multi === "single" ? undefined : d);
                    } })));
        case !!link:
            return react_1.default.createElement(Tags_1.TagLink, { XS: options.S, to: link, display: d.display, color: options.color });
        default:
            return react_1.default.createElement(Tags_1.TagDisplay, { XS: options.S, display: d.display });
    }
};
exports.genTagComp = genTagComp;
